import { useUserContext } from "../components/UserContextProvider";
import { TenantRole } from "../models/Tenant";

const ROOT_PERMISSION = 64;

export function useTenantPermission() {
    const { userTenant, user } = useUserContext();

    const myRole = (): TenantRole | null => {
        if ((user().permissions ?? 0) & ROOT_PERMISSION) return TenantRole.Owner;
        const membership = userTenant();
        if (!membership) return null;
        return membership.role as TenantRole;
    };

    const hasRole = (min: TenantRole): boolean => {
        const role = myRole();
        if (role === null) return false;
        return role >= min;
    };

    return { myRole, hasRole };
}
